import logoLight from "./images/logo/logo-light.png";
import logoDark from "./images/logo/logo-dark.png";
import dhl from "./images/partners/dhl.png";
import dpd from "./images/partners/dpd.png";
import emirates from "./images/partners/emirates.png";
import ethiopian_airlines from "./images/partners/ethiopian-airlines.png";
import fedex from "./images/partners/fedex.png";
import kenya_airways from "./images/partners/kenya-airways.png";
import maersk_group from "./images/partners/maersk_group.png";
import msc_cruises from "./images/partners/msc-cruises.png";
import turkish_airlines from "./images/partners/turkish-airlines.png";
import united_parcel from "./images/partners/united-parcel.png";

const partners = [
    dhl,
    dpd,
    emirates,
    ethiopian_airlines,
    fedex,
    kenya_airways,
    maersk_group,
    msc_cruises,
    turkish_airlines,
    united_parcel,
]

export {
    partners,
    logoLight,
    logoDark,
}
